
























<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
    white--text
  >
    <v-container fluid>
      <v-layout
        row
        justify-center
        wrap
      >
        <v-flex
          xs12
          md6
        >
          <v-text-field
            v-model="firstName"
            :rules="form.rules.nameRules"
            label="*First Name"
            required
          ></v-text-field>
        </v-flex>
        <v-flex
          xs12
          md6
        >
          <v-text-field
            v-model="lastName"
            :rules="form.rules.nameRules"
            label="*Last Name"
            required
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid>
      <v-layout
        row
        justify-center
        wrap
      >
        <v-flex
          xs12
          md5
        >
          <v-text-field
            v-model="email"
            :rules="form.rules.emailRules"
            label="*E-mail"
            required
          ></v-text-field>
        </v-flex>
        <v-flex
          xs12
          md4
        >
          <v-text-field
            mask="phone"
            v-model="phone"
            :rules="form.rules.phoneRules"
            label="*Phone #"
            required
          ></v-text-field>
        </v-flex>
        <v-flex
          xs8
          sm5
          md3
        >
          <v-checkbox
            :label="textOrNoText()"
            v-model="textable"
          />
        </v-flex>
      </v-layout>
    </v-container>
    <v-container
      fluid
      v-if="!otherDropOff"
    >
      <v-checkbox
        label="Did someone else drop off your beef?"
        v-model="otherDropOff"
      />
    </v-container>
    <v-container
      fluid
      v-if="otherDropOff"
    >
      <v-layout
        row
        justify-center
        wrap
      >
        <v-flex
          xs12
          md1
        >
          <v-checkbox
            @click="dropOffClear()"
            v-model="otherDropOff"
          />
        </v-flex>
        <v-flex
          xs12
          md4
        >
          <v-text-field
            v-model="dropOffFirstName"
            :rules="form.rules.nameRules"
            label="*Their First Name"
            required
          ></v-text-field>
        </v-flex>
        <v-flex
          xs12
          md4
        >
          <v-text-field
            v-model="dropOffLastName"
            :rules="form.rules.nameRules"
            label="*Their Last Name"
            required
          ></v-text-field>
        </v-flex>
        <v-flex
          xs12
          md3
        >
          <v-text-field
            mask="phone"
            v-model="dropOffPhone"
            :rules="form.rules.phoneRules"
            label="*Their Phone #"
            required
          ></v-text-field>
        </v-flex>
      </v-layout>

    </v-container>
    <v-container fluid>
      <v-layout
        row
        wrap
      >
        <v-flex xs12>
          <v-text-field
            v-model="form.cowId"
            label="Animal ID #"
          >
            <v-tooltip
              slot="append-outer"
              left
            >
              <v-icon
                slot="activator"
                color="primary"
              >fas fa-question-circle</v-icon>
              <span left>If you got a text from us when your animal was dropped off; you have an ID#. If not - no worries we will find it for you. If we have any questions we will give you a call, text, or email.</span>
            </v-tooltip>
          </v-text-field>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid>
      <v-layout
        row
        wrap
      >
        <v-flex xs12>
          <v-textarea
            rows="1"
            row-height="15"
            auto-grow
            v-model="form.cutNotes"
            label="Notes for us -------- (Please remember we will try our best to accommodate, but even we have limits.)"
          >
            <v-tooltip
              slot="append-outer"
              left
            >
              <v-icon
                slot="activator"
                color="primary"
                left
              >fas fa-question-circle</v-icon>
              <span>Please remember we will try our best to accommodate, but even we have limits.</span>
            </v-tooltip>
          </v-textarea>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import { mapFields } from 'vuex-map-fields'

export default {
 name: 'basicInfo',
 data: () => ({
  otherDropOff: false,
 }),
 methods: {
  dropOffClear() {
   if (this.otherDropOff) {
    this.dropOffFirstName = ''
    this.dropOffLastName = ''
    this.dropOffPhone = ''
    return (this.otherDropOff = false)
   } else {
    return true
   }
  },
  textOrNoText() {
   if (this.form.textable) {
    return 'May we text you?  YES'
   } else {
    return 'May we text you?  NO'
   }
  },
  validate() {
   if (this.$refs.form.validate()) {
    return true
   } else {
    false
   }
  },
 },
 computed: {
  ...mapFields('data', [
   'form',
   'form.dropOffFirstName',
   'form.firstName',
   'form.lastName',
   'form.phone',
   'form.email',
   'form.textable',
   'form.cowId',
   'form.dropOffPhone',
   'form.dropOffLastName',
   'form.valid',
  ]),
 },
}
</script>

<style>
</style>
